/** @flow */

import SearchUtility from "./SearchUtility";
import { INDEX_MODES } from "./constants";

export type { IndexMode } from "./constants";

export default SearchUtility;
export { INDEX_MODES, SearchUtility };



// WEBPACK FOOTER //
// ./src/util/index.js